

import React, { useState,useEffect,useContext } from 'react';
import "./DepartmentsList.scss";
import water  from '../../assests/water.jpg'
import sanitation  from '../../assests/sanitation.jpg'
import street  from '../../assests/street.jpg'
import graffiti  from '../../assests/graffiti.png'
import  noise from '../../assests/Noise-Pollution.png'
import parking  from '../../assests/parking-area.png'
import publicHealth  from '../../assests/publichealth.jpg'
import animalcontrol  from '../../assests/pet-friendly_2059740.png'
import streeetLight  from '../../assests/street.jpg'
import { useNavigate } from "react-router";
import Axios from "../../Helpers/Interceptors";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import image  from '../../assests/logo.svg'
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Space,

  Select,
  DatePicker,
  TimePicker,
  Tabs,
  Tag,
  Card,Tooltip,
  Modal, Switch,
} from "antd";
import { toast } from "react-toastify";


import { UserInfo } from "../../Context/userInfo";
import {getRole} from '../../Helpers/utils'
const DepartmentsList = () => {

  const { userData, updateUserData } = useContext(UserInfo);
  const navigate = useNavigate();
  const [Name, setName] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false); // State to manage confirmation modal visibility
  const [loading, setloading] = useState(false);
  const validationSchema = Yup.object().shape({
    emailOrPhone: Yup.string()
      .required("Email is required *")
      .email("Email is invalid"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters *")
      .required("Password is required *"),
  });
   const handleSubmit = async (values,reset) => {

    try {
      setloading(true);
      const response = await Axios.post('auth/signin', values);
      if(response.status == 200 ){
        setConfirmModalOpen(false)
        localStorage.clear()
         localStorage.setItem('token',response.data.data.accessToken)

         updateUserData(response.data)
         console.log(response.data)
         const role = getRole(response.data.data?.userInfo?.roles)
         if(role == 'DEPARTMENT'){
          navigate("/Departments-tickets");
         }else{
          navigate("/Dashboard");
         }

         toast.success(response.data.message);
      }else if(response.status == 401 ){
        toast.error(response.response.request.data);
      }
      toast.error(response.response.data);
      setloading(false);
    } catch (error) {
      console.log(error)
      toast.error(error);
      setloading(false);
    }
  };


  const  Focus = event => {
    var foo = document.querySelector("input");
    foo.setAttribute("autoComplete", "off");


   }

    const departments = [
        {
          isdisabled:false,
          id: 1,
          name: 'Sanitation Services',
          phone: '311',
          email: 'sanitation@city.gov',
          photo: sanitation
        },
        {
          isdisabled:false,
          id: 2,
          name: 'Water Department',
          phone: '311',
          email: 'water@city.gov',
          photo: water
        },
        {
          isdisabled:false,
          id: 3,
          name: 'Public',
          phone: '311',
          email: 'streets@city.gov',
          photo: street
        },
        {
          isdisabled:true,
          id: 4,
          name: 'Animal Control',
          phone: '311',
          email: 'animals@city.gov',
          photo: animalcontrol
        },
        {
          isdisabled:true,
          id: 5,
          name: 'Graffiti Removal',
          phone: '311',
          email: 'graffiti@city.gov',
          photo: graffiti
        },
        {
          isdisabled:true,
          id: 6,
          name: 'Noise Complaints',
          phone: '311',
          email: 'noise@city.gov',
          photo: noise
        },
        {
          isdisabled:true,
          id: 7,
          name: 'Parking Violations',
          phone: '311',
          email: 'parking@city.gov',
          photo: parking
        },
        {
          isdisabled:true,
          id: 8,
          name: 'Streetlight Outage',
          phone: '311',
          email: 'lights@city.gov',
          photo: streeetLight
        },
        {
          isdisabled:true,
          id: 9,
          name: 'Public Health',
          phone: '311',
          email: 'health@city.gov',
          photo: publicHealth
        }
      ];


      const cancelToggle = () => {
        // setUserToToggle(null);
        setConfirmModalOpen(false);
        // getUser(userData?.id); // Close the confirmation modal without any changes
      };

  return (
    <>
      <div
        className="signup-content2 "
        style={{
          paddingLeft: "2%",
          paddingRight: "2%",
          paddingTop: "1%",
          height: "100vh",
        }}>
    {/* <div
    className="card  mb-3  p-2"
    style={{
      background: "rgb(78 155 1 / 69%)",
      textAlign: "left",
    }}
  >
    <h5 style={{ color: "whitesmoke", marginBottom: "0px" }}>
      {" "}
      Departments{" "}
    </h5>
  </div> */}
    <div className="card-grid" style={{background:'rgba(31, 41, 53, 255)'}}>
      {departments.map(dept => (
       <div className="card1">
       <img src={dept.photo} alt={dept.name} className="card-img" />
       <h3>{dept.name}</h3>
       <p><span role="img" aria-label="phone">📞</span> {dept.phone}</p>
       <p><span role="img" aria-label="email">✉️</span> {dept.email}</p>

       {!dept.isdisabled &&  <button className="login-btn mb-5"  disabled={dept.isdisabled} onClick={()=>{setConfirmModalOpen(true); setName(dept.name)}}>Go To Dashboard</button>}
     </div>

      ))}
    </div>
    </div>







    <Modal
          open={confirmModalOpen}
          onCancel={cancelToggle}
          destroyOnClose={true}
          footer={null}
          maskClosable={false}
        >
          <div className="signup-content-model1">

            <div className="submit-container1" style={{ marginTop: "20px" }}>
            <Formik
            enableReinitialize
              initialValues={{ emailOrPhone: "", password: "" }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                handleSubmit(values,resetForm);

              }}
            >
              {({ errors, touched }) => (
                <Form id="signup-form" className="signup-form"
               >
                  <div className="register-logo mb-3">
                    <div className="logo-resize d-flex" style={{justifyContent: 'center'}}>

                    <span><h3 style={{ marginTop: '10%',
                    fontFamily: 'Myriad Pro',
                    fontSize: 'xx-large',
                    color: 'rgba(130,195,65,255)'}}>Login As  {Name}</h3></span>

                    </div>

                    {/* <h2>Admin Login</h2> */}
                  </div>

                  <div className="form-group">

                    <Field
                      className={`form-input ${errors.emailOrPhone && touched.emailOrPhone ? 'error' : ''}`}
                      name="emailOrPhone"
                      id="emailOrPhone"
                      placeholder="Email*"
                       onFocus={Focus}
                       autoComplete="new-password"
                    />
                    <ErrorMessage name="emailOrPhone">
                      {msg => (
                        <span className="error-message">
                          <i className="fa-solid fa-circle-info fa-xl"></i>
                          {msg}
                        </span>
                      )}
                    </ErrorMessage>
                  </div>

                  <div className="form-group">

                    <div className="input-group">
                      <Field
                        className={`form-input ${errors.password && touched.password ? 'error' : ''}`}
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password*"
                        id="password"
                        onFocus={Focus}
                        autoComplete='nope'

                      />
                      <i
                        className={`far ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: 'pointer', marginLeft: '-30px', marginTop:'24px' }}
                      ></i>
                    </div>
                    <ErrorMessage name="password">
                      {msg => (
                        <span className="error-message">
                          {/* <i className="fa-solid fa-circle-info fa-xl"></i> */}
                          {msg}
                        </span>
                      )}
                    </ErrorMessage>
                    <div className="forgot-password" style={{textAlign:"right"}}>
    {/* <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link> */}
  </div>
                  </div>

                  <div className="form-group">
                    <button className="form-submit" type="submit">Log in</button>
                  </div>


                </Form>
              )}
            </Formik>
              <button
                className="submit-button2"
                type="button"
                onClick={() => cancelToggle()}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
    </>
  );
};

export default DepartmentsList;
